import React, { useState, useCallback, useEffect, forwardRef, useImperativeHandle } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import {
    GetLookupData, GetCustomerGridGridData, GetOrderDetailGridData, GetArOpenItemGridData
    , GetItemMasterGridData, GetCustomerOrders
} from "../../../../services/SalesOrderService";
import CustomerOrdersResult from "./customerOrdersResult";
import AROpenItemsResult from "../salesOrdersTab/AROpenItemsResult";
import ItemMasterResult from "../salesOrdersTab/ItemMasterResult";
import CustomerResult from "../salesOrdersTab/CustomerResult";
import CustomerContactResult from "../salesOrdersTab/CustomerContactResult";
import CustomerPurchasedItemsResult from "./customerPurchasedItemsResult";
const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];
const CustomerTabs = forwardRef((props, ref) => {
    const orderStatusOpen = '0';
    const orderStatusHistorical = '1';
    const orderStatusAll = '2';
    const orderDetailTab = 1;
    const arOpenItemsTab = 2;
    const itemMasterTab = 3;
    const customerTab = 4;
    const customerContactTab = 5;
    const customerOpenOrderTab = 6;
    const customerHistoricalOrderTab = 7;
    const customerAllOrdersTab = 8;
    const customerPurchasedItemsTab = 9;
    const getSalesOrderUrl = "om/SaleOrder/SalesOrderSearch";
    const getOrderDetailSearchUrl = "om/SaleOrder/GetCustomerOrders";
    const getArOpenItemshUrl = "om/SaleOrder/GetArOpenItems";
    const GetItemMasterDetailsUrl = "om/SaleOrder/GetItemMasterMain";
    const getProfileUrl = "om/SaleOrder/GetProfiles";
    const getCustomerListUrl = "om/SaleOrder/GetCustomerList";
    const getCustomerUrl = "om/SaleOrder/GetCustomers";
    const GetCustomerConcatsUrl = "om/SaleOrder/GetCustomerConcats";
    const GetCustomePurchasedItemsUrl = "om/SaleOrder/GetCustomerPurchasedItems";
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [dataSource, setDataSource] = useState(null);
    const [orderDetailDataSource, setOrderDetailDataSource] = useState(null);
    const [arOpenItemsDataSource, setArOpenItemsDataSource] = useState(null);
    const [ItemMasterDataSource, setItemMasterDataSource] = useState(null);
    const [customerDataSource, setCustomerDataSource] = useState(null);
    const [customerContactDataSource, setCustomerContactDataSource] = useState(null);
    const [customerPurchasedItemsDataSource, setCustomerPurchasedItemsDataSource] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);
    const [activeTab, setActiveTab] = useState(arOpenItemsTab);

    useImperativeHandle(ref, () => ({
        updateData(data) {
            setSelectedRow(data);
        }
    }));

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };
    const LoadTabsData = () => {
        if(selectedRow){
        if (selectedRow.rowid && activeTab === customerOpenOrderTab) {
            var resultData = GetCustomerOrders(props.accessToken, getOrderDetailSearchUrl, selectedRow.rowid, orderStatusOpen);
            setOrderDetailDataSource(resultData);
        } else if (selectedRow.rowid && activeTab === customerHistoricalOrderTab) {
            var resultData = GetCustomerOrders(props.accessToken, getOrderDetailSearchUrl, selectedRow.rowid, orderStatusHistorical);
            setOrderDetailDataSource(resultData);
        } else if (selectedRow.rowid && activeTab === arOpenItemsTab) {
            var resultData = GetArOpenItemGridData(props.accessToken, getArOpenItemshUrl, selectedRow.rowid);
            setArOpenItemsDataSource(resultData);
        } else if (selectedRow.rowid && activeTab === customerContactTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, GetCustomerConcatsUrl, selectedRow.rowid);
            setCustomerContactDataSource(resultData);
        } else if (selectedRow.rowid && activeTab === customerAllOrdersTab) {
            var resultData = GetCustomerOrders(props.accessToken, getOrderDetailSearchUrl, selectedRow.rowid, orderStatusAll);
            setOrderDetailDataSource(resultData);
        } else if (selectedRow.rowid && activeTab === customerPurchasedItemsTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, GetCustomePurchasedItemsUrl, selectedRow.rowid);
            setCustomerPurchasedItemsDataSource(resultData);
        }
        else if (activeTab === itemMasterTab) {
            var resultData = GetItemMasterGridData(props.accessToken, GetItemMasterDetailsUrl);
            setItemMasterDataSource(resultData);
        } else if (activeTab === customerTab) {
            var resultData = GetItemMasterGridData(props.accessToken, getCustomerListUrl);
            setCustomerDataSource(resultData);
        }
    }
    }
    useEffect(() => {
        LoadTabsData();
    }, [selectedRow, activeTab]);
    return (
        <div>
            <div className="tab-bar">
                <div
                    className={`tab ${activeTab === arOpenItemsTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(arOpenItemsTab)}
                >
                    AR Open Items
                </div>
                <div
                    className={`tab ${activeTab === itemMasterTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(itemMasterTab)}
                >
                    Item Master
                </div>
                <div
                    className={`tab ${activeTab === customerTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerTab)}
                >
                    Customer
                </div>
                <div
                    className={`tab ${activeTab === customerContactTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerContactTab)}
                >
                    Customer Contact
                </div>
                <div
                    className={`tab ${activeTab === customerOpenOrderTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerOpenOrderTab)}
                >
                    Customer Open Orders
                </div>
                <div
                    className={`tab ${activeTab === customerHistoricalOrderTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerHistoricalOrderTab)}
                >
                    Customer Historical Orders
                </div>
                <div
                    className={`tab ${activeTab === customerAllOrdersTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerAllOrdersTab)}
                >
                    Customer All Orders
                </div>
                <div
                    className={`tab ${activeTab === customerPurchasedItemsTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(customerPurchasedItemsTab)}
                >
                    Customer Purchased Items
                </div>
            </div>
            {activeTab === customerOpenOrderTab && (
                <CustomerOrdersResult data={orderDetailDataSource} />
            )}
            {activeTab === customerHistoricalOrderTab && (
                <CustomerOrdersResult data={orderDetailDataSource} />
            )}
            {activeTab === customerAllOrdersTab && (
                <CustomerOrdersResult data={orderDetailDataSource} />
            )}
            {activeTab === arOpenItemsTab && (
                <AROpenItemsResult data={arOpenItemsDataSource} />
            )}
            {activeTab === itemMasterTab && (
                <ItemMasterResult data={ItemMasterDataSource} />
            )}
            {activeTab === customerTab && (
                <CustomerResult data={customerDataSource} />
            )}
            {activeTab === customerContactTab && (
                <CustomerContactResult data={customerContactDataSource} />
            )}
            {activeTab === customerPurchasedItemsTab && (
                <CustomerPurchasedItemsResult data={customerPurchasedItemsDataSource} />
            )}
        </div>
    );
});

export default CustomerTabs;